import {
  Button,
  Col,
  Divider,
  Form,
  Row,
  Spin,
  Typography,
  Upload,
} from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useState } from "react";
import { SupplierFile, SupplierFileTable } from "../../../../../api";
import { UploadFile } from "antd/lib";
import { basePath } from "../../../../../api";
import { useParams } from "react-router-dom";

import { notification } from "antd";
import ApiResponse from "../../../../../api/models/response";

type FilesFormProps = {
  type: string;
  row: SupplierFileTable;
  file?: SupplierFile;
  add: (v: any) => void;
  update: (v: any) => void;
};

let keyToken = process.env.REACT_APP_LOCAL_STORAGE_TOKEN_KEY || "";

const SupplierFilesForm = (p: FilesFormProps) => {
  const { type, row, file, add, update } = p;
  const { Text } = Typography;
  const [form] = Form.useForm();
  const fileList: UploadFile[] = [];
  const [fileBlob, setFileBlob] = useState<Blob | null>(null);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  if (file) {
    fileList.push({
      uid: file.id.toString(),
      name: file.name,
      status: "done",
      url: file.fileUrl,
    });
  }

  const addFileFunction = async (values: any) => {
    setLoading(true);
    try {
      if (!fileBlob) return;

      const url = `${basePath}/suppliers/${id}/files`;
      const formData = new FormData();

      formData.append(row.key, values.file.file.originFileObj);

      const isEdit = type === "edit";

      if (isEdit && file?.id) {
        formData.append("file_id", String(file.id));
        formData.append("supplier_id", String(id));
      }

      const fetchParams: RequestInit = {
        method: isEdit ? "PUT" : "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem(keyToken)}`,
        },
        body: formData,
      };

      const response = await fetch(url, fetchParams);
      const json = (await response.json()) as ApiResponse<any>;

      if (json.statusCode === 200) {
        notification.success({
          message: isEdit
            ? "Archivo editado correctamente"
            : "Archivo subido correctamente",
        });

        const savedFile = isEdit
          ? (json.response as SupplierFile)
          : (json.response.savedFiles[0] as SupplierFile);

        if (json.response.message) {
          notification.warning({
            message: json.response.message,
          });
        }
        
        isEdit ? update(savedFile) : add(savedFile);
      } else {
        notification.warning({
          message: json.message,
        });
      }
    } catch (error) {
      notification.error({
        message: "Error al procesar el archivo",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Spin spinning={loading}>
      <Form name="file" form={form} onFinish={addFileFunction}>
        <Divider />
        <Row style={{ display: "flex", justifyContent: "center" }}>
          <Col xs={20}>
            <Row style={{ marginBottom: 20 }}>
              <Col xs={24} md={14} style={{ marginBottom: 20 }}>
                <Text style={{ fontSize: 18, fontWeight: 500 }}>
                  {/* {JSON.stringify(file)} */}
                  {file?.name_description}
                  {file === undefined && row.name_description}
                </Text>
                <Col>
                  <Text style={{ fontSize: 16, fontWeight: 500 }}>
                    Un solo documento
                  </Text>
                </Col>
              </Col>
              <Col xs={24} md={8}>
                <Form.Item name="file">
                  <Upload
                    accept=".pdf"
                    defaultFileList={[...fileList]}
                    listType="picture"
                    maxCount={1}
                    style={{ width: "100% !important" }}
                    customRequest={({ file, onSuccess, onError }) => {
                      if (onSuccess) {
                        onSuccess("ok");
                        setFileBlob(file as Blob);
                      }
                    }}
                  >
                    <Button
                      style={{ width: 195, marginLeft: 0 }}
                      className="btn-download"
                      icon={<UploadOutlined />}
                    >
                      Subir archivo
                    </Button>
                  </Upload>
                </Form.Item>
              </Col>
            </Row>

            <Row justify="end">
              <Form.Item>
                <Button
                  htmlType="submit"
                  className="btn-add"
                  disabled={type === "watch" || loading}
                  loading={loading}
                >
                  Guardar
                </Button>
              </Form.Item>
            </Row>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default SupplierFilesForm;
